import React, {useState} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS, List, Map} from "immutable";
import {getWarehouseLabelFromId} from "../../lib/WarehouseHelper";
import PanelHeaderItem from "../../components/PanelHeaderItem";
import WarehouseJobsList from "./views/WarehouseJobsList";
import SearchQueriesPanel from "../../components/panels/SearchQueriesPanel";
import FilterPanel from "../../components/panels/FilterPanel";

// Filter options used in the right hand panel
const filterOptions = fromJS([
  {id: "", label: "All"},
  {id: "active", label: "Active"},
  {id: "late", label: "Late"},
  {id: "cancelled", label: "Cancelled"},
]);

const searchOptions = fromJS([
  {prop: "orgOrderId", label: "Order ID", type: "string"},
  {prop: "recipientName", label: "Recipient Name", type: "string"},
  {prop: "state", label: "State", type: "string"},
  {prop: "prepDate", label: "Preparation Date", type: "string"},
  {prop: "pickupDate", label: "Pickup Date", type: "string"},
  {prop: "packageState", label: "Package State", type: "string"},
  {prop: "packageTrackingNumber", label: "Tracking Number", type: "string"},
  // {prop: "packageSerialNumber", label: "Serial Number", type: "string"},
])

const PANELS = {
  GENERAL: "general",
  SEARCH: "search",
}

function WarehouseJobsPage(props) {
  const [selectedPanelId, setSelectedPanelId] = useState(PANELS.GENERAL);
  const [selectedJobId, setSelectedJobId] = useState(null);

  const handlePanelItemSelection = (id) => {
    setSelectedPanelId(id);
  }

  const warehouseId = props.params.warehouseId;
  let view = renderView(props, selectedJobId, setSelectedJobId);
  let panels = renderPanels(props, selectedPanelId);

  const title = getWarehouseLabelFromId(warehouseId) + " - Jobs Listing";

  return (
    <div className="WarehouseJobsPage SecurePage">
      <AppSidebar />
      <PageHeader title={title}/>
      <div className="PageContainer">
        {view}
      </div>
      <div className="PanelContainer">
        <div className="header">
          <PanelHeaderItem label="Filter" id={PANELS.GENERAL} selectedId={selectedPanelId} onClick={handlePanelItemSelection} />
          <PanelHeaderItem label="Search" id={PANELS.SEARCH} selectedId={selectedPanelId} onClick={handlePanelItemSelection} />
        </div>
        {panels}
        <PanelGroupController title="Actions">
          <ActionButton
            show={false}
            label="aze"
            onClick={() => console.log("aze")} />
        </PanelGroupController>
      </div>
    </div>
  )
}

function renderView(props, selectedJobId, setSelectedJobId) {
  let searchQueries = Map(props.router.location.query);

  return (
    <WarehouseJobsList
      warehouseId={props.params.warehouseId}
      selectedId={selectedJobId}
      onSelectionChange={setSelectedJobId}
      filters={searchQueries.toJS()}
      requestOrderDetail={props.requestOrderDetail}
    />
  );
}

function renderPanels(props, selectedPanelId) {
  const panels = selectedPanelId === PANELS.GENERAL
    ? List([FilterPanel])
    : List([SearchQueriesPanel]);
  
  return buildPanels(props, panels);
}

function buildPanels(props, panels) {
  return panels.map(x => buildPanel(props, x));
}

function buildPanel(props, component) {
  switch(component) {
    case FilterPanel:
      return <FilterPanel
              key="WarehouseJobsFilterPanel"
              title="Jobs Filter"
              expanded={true}
              options={filterOptions}
              defaultFilter="active"
              router={props.router}
            />
    case SearchQueriesPanel:
      return <SearchQueriesPanel
              key="SearchQueriesPanel"
              expanded={true}
              properties={searchOptions}
              router={props.router}
            />
    default:
      return null;      
  }
}

export default WarehouseJobsPage;